import React, { useState } from 'react';
import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { ELSIcon } from '@els/els-component-form-field-react';
import { onKeyDownHandler } from 'helpers/ui.helper';
import TableRow from './table-row/TableRow';
var TableCard = function (props) {
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    var _b = useState(props.rows), rows = _b[0], setRows = _b[1];
    var onClickHandler = function () {
        setIsActive(function (prevIsActive) { return !prevIsActive; });
        if (props.customExpandRows) {
            if (isActive) {
                setRows(props.rows);
            }
            else {
                setRows(props.customExpandRows);
            }
        }
    };
    var renderExpandButton = function () {
        var icon = isActive ? 'chevron-up' : 'chevron-down';
        var expandText = isActive ? 'Show less' : 'Show more';
        return (<div role="button" tabIndex={0} onClick={onClickHandler} onKeyDown={function (evt) { return onKeyDownHandler(evt, onClickHandler); }}>
        <TableRow customClass="c-table-card__expand-button" header={expandText} content={<ELSIcon name={icon} size="1x1o2"/>}/>
      </div>);
    };
    var renderExpandContent = function () {
        var _a;
        var expandedContent = (<div className="c-els-accordion c-els-accordion--no-indent">
        <div>
          {isActive && (<div className="c-els-accordion__body">
              {(_a = rows === null || rows === void 0 ? void 0 : rows.expanded) === null || _a === void 0 ? void 0 : _a.map(function (row) {
                    return <TableRow key={uuidv4()} {...row} data={props.data}/>;
                })}
            </div>)}
          {renderExpandButton()}
        </div>
      </div>);
        return rows.expanded ? expandedContent : '';
    };
    return (<div className={classnames('c-els-accordion c-table-card', props.data.cssModifier)}>
      <div className="c-table-card__title">
        {props.title}
        {props.hideTitleIcon ? '' : <ELSIcon customClass="u-els-margin-left-3o4 c-table-card__title-arrow-icon" name="chevron-right" size="1x1o2"/>}
      </div>
      <div className="c-table-card__content">
        {rows.default.map(function (row) {
            return <TableRow key={uuidv4()} {...row} data={props.data} isActive={isActive}/>;
        })}
        {renderExpandContent()}
      </div>
    </div>);
};
export default TableCard;
